import { VideoMediaCenterPlugin } from './video-media-center-plugin'
import { PLUGIN_NAME } from './plugin-name'

// eslint-disable-next-line import/prefer-default-export
export function register (videojs = global.videojs) {
  // Cross-compatibility for Video.js 5 and 6.
  const registerPlugin = videojs.registerPlugin || videojs.plugin

  registerPlugin(PLUGIN_NAME, VideoMediaCenterPlugin)
}
